import { Component, Host, Prop, h } from "@stencil/core";

@Component({
    tag: "ux-iws-teaser-sidebar-icon",
    styleUrl: "teaser-sidebar-icon.scss",
})
export class SidebarIconList {
    private baseClass = "ux-iws-teaser-sidebar-icon";

    /** if set, the content of the teaser will be center-aligned for tablet and mobile viewports */
    @Prop() contentElement: boolean = false;

    render() {
        return (
            <Host class={this.baseClass}>
                <ux-iws-link-wrapper
                    class={{
                        [`${this.baseClass}__wrapper`]: true,
                        [`${this.baseClass}__wrapper--content-element`]:
                            this.contentElement,
                    }}
                >
                    <slot name="icon" />
                    <div class={`${this.baseClass}__text-content`}>
                        <slot name="title" />
                        <slot name="link" />
                        <slot />
                    </div>
                </ux-iws-link-wrapper>
            </Host>
        );
    }
}
